import { RouterPath } from '@/routes/RouterPath';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { HomeViewType, SettingViewType, HomeTabType } from '@/core/presenter/viewModel';

interface IProps {
  viewType?: HomeViewType;
  settingViewType?: SettingViewType;
  activeTab?: HomeTabType;
  onChangeTabType?: (type: HomeTabType) => void;
  onMoveMainView?: () => void;
  onMoveSettingMainView?: () => void;
  onResetSelectedAsset?: () => void;
  resetSendInfo?: () => void;
}

const FooterBar = ({
  viewType,
  settingViewType,
  activeTab,
  resetSendInfo,
  onChangeTabType,
  onMoveMainView,
  onMoveSettingMainView,
  onResetSelectedAsset,
}: IProps) => {
  const navigate = useNavigate();

  const handleMoveMainView = useCallback(() => {
    if (viewType !== HomeViewType.MAIN) {
      navigate(RouterPath.HOME, { replace: true });
    }

    if (activeTab === HomeTabType.ACTIVITIES && onChangeTabType) {
      onChangeTabType(HomeTabType.ASSETS);
    }

    if (onMoveMainView) onMoveMainView();

    if (onResetSelectedAsset) onResetSelectedAsset();

    if (resetSendInfo) resetSendInfo();
  }, [viewType, activeTab, onChangeTabType, onMoveMainView, onResetSelectedAsset, resetSendInfo, navigate]);

  const handleMoveSettingMainView = useCallback(() => {
    if (settingViewType !== SettingViewType.MAIN) {
      navigate(RouterPath.SETTING, { replace: true });
    }

    if (onMoveSettingMainView) onMoveSettingMainView();
  }, [settingViewType, onMoveSettingMainView, navigate]);

  return (
    <footer>
      <nav className="bottom-nav">
        <button type="button" className="nav-btn active" id="homeBtn" onClick={handleMoveMainView}>
          <img src="./images/gdf-logo.png" alt="홈" className="nav-icon" />
          <span className="nav-label active text-xs font-medium">홈</span>
        </button>
        <button type="button" className="nav-btn">
          <img src="./images/purchase-icon.png" alt="구매하기" className="nav-icon" />
          <span className="nav-label text-xs font-medium">구매하기</span>
        </button>
        <button type="button" className="nav-btn">
          <img src="./images/purchase-list-icon.png" alt="구매내역" className="nav-icon" />
          <span className="nav-label text-xs font-medium">구매내역</span>
        </button>
        <button type="button" className="nav-btn" id="settingBtn" onClick={handleMoveSettingMainView}>
          <img src="./images/setting-icon-active.png" alt="설정" className="nav-icon" />
          <span className="nav-label active text-xs font-medium">설정</span>
        </button>
      </nav>
      {/* <nav>
        <ul>
          <li>
            <a className="pointer_cursor" onClick={handleMoveMainView}>
              <img src="images/GDF_symbol.png" alt="bi" / />
              <p>홈</p>
            </a>
          </li>
          <li>
            <a href="#" className="default_cursor" onClick={(e) => e.preventDefault()}>
              <img src="images/purchase-icon.png" alt="send-icon" className="img_disabled" / />
              <p className="text_disabled">구매하기</p>
            </a>
          </li>
          <li>
            <a className="default_cursor" onClick={(e) => e.preventDefault()}>
              <img src="images/purchase-list-icon.png" alt="rcv-icon" className="img_disabled" / />
              <p className="text_disabled">구매내역</p>
            </a>
          </li>
          <li>
            <a className="pointer_cursor" onClick={handleMoveSettingMainView}>
              <img src="images/config-icon.png" alt="config-icon" / />
              <p>설정</p>
            </a>
          </li>
        </ul>
      </nav> */}
    </footer>
  );
};

export default FooterBar;
